import { render, staticRenderFns } from "./BrandSuccessResult.vue?vue&type=template&id=118fbd5a&scoped=true&"
import script from "./BrandSuccessResult.vue?vue&type=script&lang=js&"
export * from "./BrandSuccessResult.vue?vue&type=script&lang=js&"
import style0 from "./BrandSuccessResult.vue?vue&type=style&index=0&id=118fbd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fbd5a",
  null
  
)

export default component.exports